/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ docs: NonNullable<unknown>, orderNumber: NonNullable<unknown> }} Orders_Generating_For_OrderInputs */

const en_orders_generating_for_order = /** @type {(inputs: Orders_Generating_For_OrderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generating ${i?.docs} for ${i?.orderNumber}...`)
};

const es_orders_generating_for_order = /** @type {(inputs: Orders_Generating_For_OrderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generando ${i?.docs} para ${i?.orderNumber}...`)
};

/**
* | output |
* | --- |
* | "Generating {docs} for {orderNumber}..." |
*
* @param {Orders_Generating_For_OrderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_generating_for_order = /** @type {((inputs: Orders_Generating_For_OrderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Generating_For_OrderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_generating_for_order(inputs)
	return es_orders_generating_for_order(inputs)
});